import { OptionsApi } from '@core/swagger-client';
import { useParams } from '@online-webinar/router';
import { useMutation } from '@tanstack/react-query';
import { useEffect } from 'react';
import ContentLoader from 'react-content-loader';
import { useTranslation } from 'react-i18next';
import { AuthPage, AuthPageContent } from '../..';
import { AuthPageTitle, VerificationFailed, VerificationSucceded } from '../../atoms';
import { AuthFormHeader } from '../../molecules';
import { RegisterSideContent } from '../../organism';

export const VerifyAccount = () => {
    const { t } = useTranslation();
    const { verificationCode } = useParams({ strict: false });
    const verifyAccountMutation = useMutation(OptionsApi.account.verify());
    useEffect(() => {
        verifyAccountMutation.mutate(verificationCode ?? '');
    }, []);

    return (
        <AuthPage>
            <AuthPageContent>
                <AuthFormHeader>
                    <AuthPageTitle testId="login" className="mb-12">
                        {verifyAccountMutation.isPending
                            ? t('Account.Verification.Pending.Title')
                            : verifyAccountMutation.isError
                              ? t('Account.Verification.Failed.Title')
                              : t('Account.Verification.Succeeded.Heading')}
                    </AuthPageTitle>
                    {!verifyAccountMutation.isPending && verifyAccountMutation.isError && <VerificationFailed />}
                    {!verifyAccountMutation.isPending && !verifyAccountMutation.isError && <VerificationSucceded />}
                    {verifyAccountMutation.isPending && (
                        <ContentLoader speed={2} width={1250} height={300} backgroundColor="#C0C0C0" foregroundColor="#ecebeb">
                            <rect x="0" y="5" width="280" height="20" />
                            <rect x="0" y="40" width="280" height="12" />
                            <rect x="0" y="70" width="280" height="12" />
                            <rect x="0" y="100" width="280" height="12" />
                            <rect x="0" y="130" width="500" height="12" />
                            <rect x="0" y="160" width="200" height="30" />
                        </ContentLoader>
                    )}
                </AuthFormHeader>
            </AuthPageContent>

            <RegisterSideContent></RegisterSideContent>
        </AuthPage>
    );
};
